import { render, staticRenderFns } from "./cont-batch-edit.vue?vue&type=template&id=8ca2f1e4&scoped=true&"
import script from "./cont-batch-edit.vue?vue&type=script&lang=js&"
export * from "./cont-batch-edit.vue?vue&type=script&lang=js&"
import style0 from "./cont-batch-edit.vue?vue&type=style&index=0&id=8ca2f1e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca2f1e4",
  null
  
)

export default component.exports